/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var enhancedTableProps = {
  beforeDragSort: {
    type: Function
  },
  tree: {
    type: Object
  },
  treeExpandAndFoldIcon: {
    type: Function
  },
  onAbnormalDragSort: Function,
  onTreeExpandChange: Function
};

export { enhancedTableProps as default };
//# sourceMappingURL=enhanced-table-props.mjs.map
